import { memo } from "react";
import { Icon, Button, Divider } from "semantic-ui-react";

// Components
import BroadcastApprovalTopBar from "./BroadcastApprovalTopBar";

// Commons
import SunEditor from "suneditor-react";

// Utils
import moment from "moment";

// Interface
import { PickedState, ActionPostBroadcast } from "./MeCastType";

// Serializers
import BroadcastPostSerializer from "issara-sdk/types/BroadcastPostSerializer_apps_PRX";

export type BroadcastApprovalDetail = {
  id: number;
  broadcastId: string;
  postDetails: string;
  images?: string[];
  groupName: string[];
  scheduleDate: string;
  status: "Pending Review" | "Approved" | "Rejected";
  editedBy: string;
  submissionDate: string;
  broadcastType: string;
  totalMembers: number;
  firebaseId?: string;
  statusCustomLabel: string;
  reviewedAt: string;
  sentReviewedBy: string;
};

type BroadcastApprovalDetailPageProps = {
  // actions
  onBack: () => void;
  onOpenLog: (broadcastPostId?: number) => void;
  onSelectAction: (action: ActionPostBroadcast) => void;
  // data
  broadcast: BroadcastPostSerializer;
  postContent: { text: string; media: string[] };
  contentLoading?: boolean;
  // loader
  actionLoading?: boolean;
} & Pick<
  PickedState, "loadingStatus"
>;

const ICON = {
  member: "/static/images/meform/member.png",
  approve: "/static/images/meform/approve.png",
  reject: "/static/images/meform/reject.png",
  warning: "/static/images/meform/warning.png",
};

const BroadcastApprovalDetailPage = (props: BroadcastApprovalDetailPageProps) => {

  return (
    <div style={{ position: "relative", padding: "20px" }}>
      {/* --- Mod Log --- */}
      {/* <ModBroadcastLog
        // func & callback
        open={props.openLog}
        onClose={props.onCloseLog}
        // data
        selectedBroadcast={props.broadcast as BroadcastPostSerializer}
        broadcastLog={props.broadcastLog}
        // loader
        loader={props.broadcastLogLoader}
      /> */}

      <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
        <Icon
          name="angle left"
          size="large"
          style={{
            cursor: "pointer",
            marginRight: "16px",
            color: "#656565",
            backgroundColor: "#ffe5e5",
            borderRadius: "4px",
          }}
          onClick={props.onBack}
        />
        <h2 style={{ margin: 0, color: "#e5436e", display: "flex", alignItems: "center" }}>
          Broadcast Approval{" "}
        </h2>
        <BroadcastApprovalTopBar
          isApprovalPage
          broadcast={props.broadcast}
          onOpenLog={props.onOpenLog}
        />
      </div>
      <Divider style={{ marginBottom: "25px", marginTop: 0 }} />
      
      {/* --- Content --- */}
      <div
        style={{
          display: "flex",
          gap: "20px",
          height: "calc(100vh - 150px)",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            flex: 1,
            border: "1px solid var(--primary-theme-color)",
            borderRadius: "4px",
            padding: "10px",
            overflowY: "auto",
          }}
        >
          {props.postContent.text ? (
            <div style={{ position: "relative", height: "100%" }}>
              <style>{`.se-resizing-bar { display: none !important; }`}</style>

              <SunEditor
                disable={true}
                setContents={props.postContent.text}
                setOptions={{ buttonList: [], height: "100%", minHeight: "calc(80vh - 2rem)"}}
              />
            </div>
          ) : (
            props.broadcast?.content || ""
          )}
        </div>

        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: "12px", display: "flex" }}>
            <div style={{ minWidth: "50%" }}>
              <strong style={{ marginRight: "10px" }}>Submission date:</strong>
              {moment(props.broadcast.sent_reviewed_at).format("DD/MM/YYYY \\[HH:mm\\]")}
            </div>
            <strong style={{ marginRight: "10px" }}>By:</strong> {props.broadcast.sent_reviewed_by_name}
          </div>

          <div style={{ marginBottom: "12px", display: "flex" }}>
            <div style={{ minWidth: "50%" }}>
              <strong style={{ marginRight: "10px" }}>Broadcast type:</strong>
              {props.broadcast.broadcast_type === "INSTANTLY" ? "Send Instantly" : "Schedule"}
            </div>
            <strong style={{ marginRight: "10px" }}>Broadcast date:</strong>
            {props.broadcast.broadcast_type !== "INSTANTLY"
              ? moment(props.broadcast.schedule_broadcasted_at).format("DD/MM/YYYY \\[HH:mm\\]")
              : "-"}
          </div>

          <div style={{ marginBottom: "12px" }}>
            <strong style={{ marginRight: "10px" }}>Group Name:</strong>
            {props.broadcast.group_name}
          </div>

          <div style={{ marginBottom: "12px", display: "flex" }}>
            <img
              src={ICON.member}
              alt="member"
              style={{
                width: "20px",
                height: "20px",
                marginBottom: "-5px",
                marginRight: "10px",
              }}
            />
            <strong>Total Member(s):</strong>{" "}
            <div
              style={{
                backgroundColor: "#ffe5e5",
                borderRadius: "4px",
                textAlign: "center",
                minWidth: "30px",
                marginLeft: "10px",
              }}
            >
              {props.broadcast.total_member_count}
            </div>
          </div>
          {props.broadcast.status === "PENDING_REVIEW" ? (
            <div
              style={{
                marginTop: "24px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <Button
                onClick={() => props.onSelectAction("REJECT")}
              >
                Reject{" "}
                <img
                  src={ICON.reject}
                  alt="reject"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginBottom: "-5px",
                  }}
                />
              </Button>
              <Button
                style={{
                  backgroundColor: "#fb6c92"
                }}
                onClick={() => props.onSelectAction("APPROVE")}
              >
                Approve{" "}
                <img
                  src={ICON.approve}
                  alt="approve"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginBottom: "-5px",
                  }}
                />
              </Button>
            </div>
          ) : (
            <div style={{ marginTop: "24px", display: "flex", marginLeft: "20px" }}>
              {props.broadcast.status === "REVIEWED" && (
                <p style={{ fontStyle: "italic" }}>
                  <strong style={{ fontStyle: "normal" }}>Approved by:</strong>{" "}
                  {props.broadcast.reviewed_by_name}{" "}
                  {moment(props.broadcast.reviewed_at).format("DD/MM/YYYY \\[HH:mm\\]")}
                  {props.broadcast.broadcast_type === "SCHEDULE" &&
                    moment().isSameOrBefore(moment(props.broadcast.schedule_broadcasted_at)) && (
                      <Button
                        style={{ backgroundColor: "#fb6c92", marginLeft: "20px" }}
                        loading={props.loadingStatus?.actionBroadcast}
                        onClick={() => props.onSelectAction("UNAPPROVE")}
                      >
                        Unapprove{" "}
                        <img
                          src={ICON.approve}
                          alt="approve"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginBottom: "-5px",
                          }}
                        />
                      </Button>
                    )}
                </p>
              )}
              {props.broadcast.status === "REVIEW_REJECTED" && (
                <p style={{ fontStyle: "italic" }}>
                  <strong style={{ fontStyle: "normal" }}>Rejected by:</strong>{" "}
                  {props.broadcast.reviewed_by_name}{" "}
                  {moment(props.broadcast.reviewed_at).format("DD/MM/YYYY \\[HH:mm\\]")}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BroadcastApprovalDetailPage;
